import { IStore } from 'store/configureStore';
import { defaultSearchState, ISearchResult } from 'shared/components/autocomplete/EntityAutocompleteWithSearch/store/reducers';

const selectAutocompleteState = (state: IStore) => state.components.entitiesAutocompleteSearch;
export const selectAutocompleteStateByKey = (searchKey: string) => (state: IStore): ISearchResult => {
    return selectAutocompleteState(state)[searchKey] || defaultSearchState;
};
